import { useEffect, useState } from 'react';
import axios from 'axios';
import ManufactureLogo from '../../assets/images/sensei-new-logo-2.0.svg'
import { useDispatch, useSelector } from 'react-redux'
import { OverlayTrigger,Popover,Tooltip } from "react-bootstrap";

const DiscountAll = () => {
    const state = useSelector((state) => state.reducer.const_var.crmSetting);
    const editAPIDataByResponse = useSelector((state) => state.reducer.const_var.editAPIDataByResponse);
    
    const [searchList, setSearchList] = useState([])
    const [userInput, setUserInput] = useState("")
    const [loader , setLoader] = useState(true)
    const [noRecordFound , setNoRecordFound] = useState(false)
    const [discount_Offers_allForComponent,setDiscountOffersAll] = useState([])
    const dispatch = useDispatch()
    const discountsList = [
        {
            value: '25%',
            logo: 'url',
            text: 'AA Metal Building Announcing Winter Special offer for metal Buildings.'
        },
        {
            value: '12%',
            logo: 'url',
            text: 'AA Metal Building Announcing Winter Special offer for metal Buildings.'
        },
    ]

    useEffect(() => {
        var apiDiscountData = {
            "api_token": state.api_token,
            "manufacturer_id": "all",
            "all_active": true
        }
        fetchData(apiDiscountData);
        //dispatch(discountApi(apiDiscountData,"all"));
    },[])

    useEffect(() => {
        if(discount_Offers_allForComponent?.length > 0){
            setLoader(false)
        }
    },[discount_Offers_allForComponent])


    const fetchData = async (apiDiscountData) => {
        let DomainURI = window.location.href
        if(DomainURI?.includes("3d-public") && editAPIDataByResponse?.data?.request_data?.sensei_sales_id){
            apiDiscountData.api_token = editAPIDataByResponse.data.request_data.api_token
        }
        const response = await axios.post(state.discount_api_url+"api/v1/crm/discounts",apiDiscountData,{"headers":state.header_key}).then((disResp) => {
          //return response.data;
          setDiscountOffersAll(disResp.data.data.results);
          if(disResp.data.data.results.length == 0){
              setLoader(false)
          }
          }).catch((disError) => {
            console.log("disError" , disError)
        })
      };
    const calHigherPercentage = (item) => {
        let num = 0
        if(item?.offers != undefined && item?.offers?.length > 0)
            item.offers.forEach((offer) => {
                if(Number(offer.amount) > Number(num)){
                    num = offer.amount
                } 
            })
        if(num > 0){
            return parseFloat(num) + "%"
        }else{
            return 0
        }
    }

    const searchData = (inputValue) => {
        
        const filteredData = discount_Offers_allForComponent?.length > 0 && discount_Offers_allForComponent.filter(item => {
            let itemName = item.manufacturer.name.toLowerCase()
            let discountName = item.name.toLowerCase()
            let userInput = inputValue.trim().toLowerCase()
            if(itemName.includes(userInput) || discountName.includes(userInput)){
                    return item
            }
        });
        if(filteredData.length > 0){
            setSearchList(filteredData)
            setNoRecordFound(false)
        }else{
            setSearchList(filteredData)
            setNoRecordFound(true)
        }
        setUserInput(inputValue)
    }

    const redirectTOCRM = (itemDetail) => {
        window.open(`${state.source}/manufacturers/${itemDetail.manufacturer_id}`,"_self")
    }
    
    let list = searchList.length > 0 ? searchList : (discount_Offers_allForComponent?.length > 0 && discount_Offers_allForComponent)

    const hitTOCRM = () => {
        window.open(`${state.source}`,"_self")
    }
    return (
        <div className='discountAll-container'>
            {/* <button className="close" onClick={() => {}}>
                <span className="icon-close"></span>
            </button> */}
           
            {
                loader 
                ? 
                    <div className='discount-all-loader'>
                        <div className="spinner-loader">
                            <div className="spinner"></div>
                            <div className='loader-text'>Loading</div>
                        </div>
                    </div>
                :
                    <>
                        <div className='discountAll-header'>
                            <div className='discountAll-title'>
                                All Discounts
                            </div>
                            <div className='discountAll-search-container'>
                                <span className='icon-search-ico'></span>
                                <input type='text' placeholder='Quick Search...' value={userInput} onChange={(e) => searchData(e.target.value)}/>
                            </div>
                        </div>
                        <div className={`discountAll-content-container ${list.length === 1 ? 'only-one-discount' : ''}`}>
                            {
                                loader == false && list != undefined && list.length > 0 && noRecordFound == false 
                                ?
                                    <>
                                        {
                                            list != undefined && list.length > 0 && list.map((item, index) => 
                                                <div key={'discount'+index} className='discountAll-content-item'>
                                                    <div className="view-detail" onClick={() => {redirectTOCRM(item)}}>
                                                        <span>VIEW DETAILS</span>
                                                        <i className="icon-arrow-long"></i>
                                                    </div>
                                                    <div className="item-content">
                                                        <div className="content-title">
                                                            {
                                                                calHigherPercentage(item) != 0
                                                                ?
                                                                    <>
                                                                        <span className="upto">UP-TO</span>
                                                                        <span className="discount-value">{ calHigherPercentage(item) } OFF</span>
                                                                    </>
                                                                :
                                                                    <span className="discount-value special-disc">Special Discount</span>
                                                            }
                                                        </div>
                                                        {/* <OverlayTrigger placement="bottom"
                                                            overlay={
                                                                <Popover className="popover-default">
                                                                    <Popover.Content>
                                                                        {item.name} : {item.description}
                                                                    </Popover.Content>
                                                                </Popover>
                                                            }
                                                        >
                                                        </OverlayTrigger> */}
                                                        <div className="content-text">
                                                            {item.name} : {item.description}
                                                        </div>
                                                        <div className="item-footer">
                                                            <div className="item-footer-title">OFFER ENDS IN :</div>
                                                            {/* {item.end_date && countDown(item.end_date , `allOffer${index}`) } */}
                                                            <div className="item-footer-content">
                                                                <div className='time-container'>
                                                                    <div className="time-end-date">{item.end_date}</div>
                                                                </div>
                                                                {/* <div className='time-container' id={`allOffer${index}`}>
                                                                    <div className="time-label">02</div>
                                                                    <div className="time-title">DAYS :</div>
                                                                </div>
                                                                <div className='time-container'>
                                                                    <div className="time-label">01</div>
                                                                    <div className="time-title">HRS :</div>
                                                                </div>
                                                                <div className='time-container'>
                                                                    <div className="time-label">08</div>
                                                                    <div className="time-title">MINS</div>
                                                                </div> */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="image-container">
                                                        <img src={item.manufacturer.logo} alt="manufacture log" />
                                                        {/* <OverlayTrigger placement="bottom"
                                                            overlay={
                                                                <Popover className="popover-default">
                                                                    <Popover.Content>
                                                                {item.manufacturer.name + item.manufacturer.name + item.manufacturer.name} 

                                                                    </Popover.Content>
                                                                </Popover>
                                                            }
                                                        >
                                                        </OverlayTrigger> */}
                                                        <div className='manufacturer-name'>
                                                            {item.manufacturer.name} 
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                    </>
                                :
                                    <div className='no-data-found'>
                                        No Record Found
                                        {
                                            noRecordFound == false ?
                                            <button
                                                onClick={() => hitTOCRM()} 
                                                className="btn btn-primary"
                                            >
                                                <span className="text">
                                                    Go to CRM
                                                </span>
                                            </button>
                                            :
                                            null
                                        }
                                    </div>

                            }
                            
                        </div>
                    </>
            }
        </div>
    )
}

export default DiscountAll